export const StatusColors: Record<string, 'red' | 'orange' | 'blue' | 'green' | 'white'> = {
	Pending: 'orange',
	pending: 'orange',
	UnderReview: 'orange',
	Rejected: 'red',
	rejected: 'red',
	Canceled: 'red',
	Expired: 'red',
	Inactive: 'red',
	Failed: 'red',
	Active: 'green',
	Completed: 'green',
	Success: 'green',
	Approved: 'green',
	Generated: 'green',
	Published: 'green',
	Ongoing: 'green',
	Released: 'green',
	Yes: 'green',
	No: 'red',
	Abstained: 'orange',
	NoVote: 'blue',
	Reversed: 'blue',
	Scheduled: 'blue',
	'': 'white',
};
